<template>
  <section class="content">
    <section class="center-section">
      <PresentationsSection
        class="presentations-section"
      >
        <template #before>
          <div class="flex justify-between">
            <h3>{{ $i18nPresenter.t('Recent') }}</h3>
            <div
              class="presentation-link link-color font-bold inline-flex items-center gap-4 cursor-pointer"
            >
              <span>{{ $i18nPresenter.t('My Presentations') }}</span>
              <aha-icon
                name="chevron-right-2"
                width="10"
                height="16"
                viewBox="0 0 8 14"
              >
              </aha-icon>
            </div>
          </div>
        </template>
        <template #after>
          <aha-skeleton-loader
            class="loader"
            width="100%"
            height="191px"
          />
        </template>
      </PresentationsSection>
      <TemplatesSection :showBrowseAll="false">
        <template #before>
          <div class="flex justify-between">
            <h3>{{ $i18nPresenter.t('Popular Templates') }}</h3>
            <div
              class="presentation-link link-color font-bold inline-flex items-center gap-4 cursor-pointer"
            >
              <span>{{ $i18nPresenter.t('Browse all') }}</span>
              <aha-icon
                name="chevron-right-2"
                width="10"
                height="16"
                viewBox="0 0 8 14"
              >
              </aha-icon>
            </div>
          </div>
        </template>
        <template #after>
          <aha-skeleton-loader
            class="loader"
            width="100%"
            height="120px"
          />
        </template>
      </TemplatesSection>
      <FeedbacksSection
        class="feedbacks-section hide-desktop"
      >
        <template #before>
          <h3 class="p-4">
            {{ $i18nPresenter.t('From your audience') }}
          </h3>
        </template>
        <template #after>
          <section class="p-4 flex flex-col gap-8">
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="80px"
            />
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="80px"
            />
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="80px"
            />
          </section>
        </template>
      </FeedbacksSection>
      <NotificationsSection v-if="!isWhiteLabel" :showNotification="false">
        <template #before>
          <h3 class="p-4 flex gap-4">
            <img src="@/assets/images/bell.svg" />
            {{ $i18nPresenter.t('Notifications') }}
          </h3>
        </template>
        <template #after>
          <section class="p-4 flex flex-col gap-8">
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="120px"
            />
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="120px"
            />
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="120px"
            />
          </section>
        </template>
      </NotificationsSection>
      <SocialMedia
        v-if="!isWhiteLabel"
        class="hide-desktop"
      >
        <template #before>
          <h3>
            {{ $i18nPresenter.t('Join us on') }}
          </h3>
        </template>
        <template #after>
          <aha-skeleton-loader
            class="loader"
            width="100%"
            height="100px"
          />
        </template>
      </SocialMedia>
    </section>
    <section class="sidebar-section hide-mobile">
      <FeedbacksSection
        v-if="!isWhiteLabel"
        class="feedbacks-section"
      >
        <template #before>
          <h3 class="p-4">
            {{ $i18nPresenter.t('From your audience') }}
          </h3>
        </template>
        <template #after>
          <section class="p-4 flex flex-col gap-8">
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="80px"
            />
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="80px"
            />
            <aha-skeleton-loader
              class="loader"
              width="100%"
              height="80px"
            />
          </section>
        </template>
      </FeedbacksSection>
      <SocialMedia v-if="!isWhiteLabel">
        <template #before>
          <h3>
            {{ $i18nPresenter.t('Join us on') }}
          </h3>
        </template>
        <template #after>
          <aha-skeleton-loader
            class="loader"
            width="100%"
            height="100px"
          />
        </template>
      </SocialMedia>
    </section>
  </section>
</template>
<script>
import PresentationsSection from './PresentationsSection.vue'
import FeedbacksSection from './FeedbacksSection.vue'
import TemplatesSection from './TemplatesSection.vue'
import NotificationsSection from './NotificationsSection.vue'
import SocialMedia from './SocialMedia.vue'

import Utils from '@/util'

export default {
  components: {
    PresentationsSection,
    FeedbacksSection,
    TemplatesSection,
    NotificationsSection,
    SocialMedia,
  },
  computed: {
    isWhiteLabel() {
      return Utils.checkWhiteLabelDomain()
    },
  },
}
</script>

  <style lang="scss" scoped>

.content {
    display: grid;
    grid-template-columns: [main-start sidebar-start] minmax(0, 1fr) [sidebar-end main-end];
    grid-auto-rows: auto;
    gap: 1rem;

    @media (min-width: 1025px) {
        &.has-sidebar-content {
          grid-template-columns:
            [main-start] minmax(0, 1fr)
            [sidebar-start main-end] minmax(200px, 377px)
            [sidebar-end];
        }
    }

    & .loader {
        border-radius: 0.5rem;
        margin-top: -1rem;
    }

    & .hide-desktop {
        @media (min-width: 1025px) {
        display: none;
    }
    }

    & .hide-mobile {
        @media (max-width: 1024px) {
        display: none !important;
    }
    }

    & > .center-section {
        grid-column: main;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    & > .sidebar-section {
        grid-column: sidebar;
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}
  </style>
